import { Model } from "pinia-orm";
import Marker from "./Marker";

export default class AosOutdoorSpace extends Model {
  static entity = "outdoor_spaces";
  static primaryKey = "uuid";
  static aosType = "OUTDOOR_SPACE";

  static typeKey = "outdoorSpaceType";

  static types() {
    return {
      OUTDOOR_SPACE_FUSION: AosOutdoorSpaceFusion,
    };
  }

  static fields() {
    return {
      uuid: this.uid(""),
      label: this.attr(null),
      usage: this.attr([]),
      pictureUuid: this.attr(null),
      tagsType: this.attr([]),
      tracerCompound: this.attr([]),
      existenceOfAConstraint: this.boolean(false),
      constraintAccuracy: this.attr(null),
      analyticalStandard: this.attr(null),
      quantificationLimit: this.attr(null),
      isSourceTakenIntoAccount: this.boolean(true),
      justification: this.attr(null),
      typology: this.attr("OUTDOOR_SPACE"),
      details: this.attr(null),
      isPollutionTraces: this.boolean(false),
      isWaterproof: this.boolean(false),
      waterproofingLayers: this.attr([]),
      reference: this.attr(null),
      remarks: this.attr(null),
      marker: this.morphOne(Marker, "markable_id", "markable_type"),
      isAsbestosRisk: this.boolean(false),
      incertitudeDescription: this.attr(null),
      incertitudeCategory: this.attr(null),
    };
  }
}

export class AosOutdoorSpaceFusion extends AosOutdoorSpace {
  static entity = "outdoorSpaceFusions";
  static primaryKey = "uuid";
  static baseEntity = "outdoor_spaces";

  static fields() {
    return {
      ...super.fields(),
      outdoorSpaces: this.attr([]),
      outdoorSpaceType: this.attr("OUTDOOR_SPACE_FUSION"),
    };
  }
}
